export const DEFAULT_PRIMARY_COLOR = '#6e56fe';
